'use client';

/**
 * ConditionalBottomNav
 *
 * A thin client island that renders <BottomNav /> only when the user is signed
 * in. Used in the (main) layout so that signed-in users navigating public pages
 * (collections, user profiles, item detail) still see the bottom tab bar.
 *
 * This avoids converting the (main) server layout to a client component just
 * to read auth state — we isolate the Clerk hook in this small island instead.
 */

import { useUser } from '@clerk/nextjs';
import { usePathname } from 'next/navigation';
import { BottomNavWithFAB } from './bottom-nav-with-fab';

const HIDE_BOTTOM_NAV = [/\/edit$/];

export function ConditionalBottomNav() {
  const { isSignedIn } = useUser();
  const pathname = usePathname();
  if (!isSignedIn) return null;
  if (HIDE_BOTTOM_NAV.some((pattern) => pattern.test(pathname))) return null;
  return <BottomNavWithFAB />;
}
